/**
 * Centralized SweetAlert2 theme configuration.
 *
 * Uses GCHL design tokens instead of hardcoded hex colors.
 * Import and spread into Swal.fire() calls:
 *
 *   Swal.fire({ ...swalConfirm, title: '...', text: '...' })
 *   Swal.fire({ ...swalDanger, title: '...', text: '...' })
 */

// GCHL Brand Tokens
const COLORS = {
  forest: '#1a472a',    // forest-950 — primary brand
  forestLight: '#15803d', // forest-700 — lighter variant
  danger: '#dc2626',    // red-600 — destructive actions
  cancel: '#6b7280',    // gray-500 — neutral/cancel
  success: '#16a34a',   // green-600 — success confirmations
  warning: '#d97706',   // amber-600 — warnings
};

/** Default confirm action (forest green) */
export const swalConfirm = {
  confirmButtonColor: COLORS.forest,
};

/** Confirm + cancel pair (forest green / gray) */
export const swalConfirmCancel = {
  confirmButtonColor: COLORS.forest,
  cancelButtonColor: COLORS.cancel,
};

/** Danger action (red confirm) */
export const swalDanger = {
  confirmButtonColor: COLORS.danger,
  cancelButtonColor: COLORS.cancel,
};

/** Danger confirm with forest cancel (for "keep" vs "delete" dialogs) */
export const swalDangerAlt = {
  confirmButtonColor: COLORS.danger,
  cancelButtonColor: COLORS.forest,
};

/** Success action (green confirm) */
export const swalSuccess = {
  confirmButtonColor: COLORS.success,
};

/** Warning action (amber confirm) */
export const swalWarning = {
  confirmButtonColor: COLORS.warning,
  cancelButtonColor: COLORS.cancel,
};

/** Info action (forest light confirm) */
export const swalInfo = {
  confirmButtonColor: COLORS.forestLight,
  cancelButtonColor: COLORS.cancel,
};
